export default __webpack_public_path__ + "static/media/fla.d4665fa5.png";